import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { List as AntdList, Alert, Spin, Switch } from 'antd';
import { Link, useLocation, useRouteMatch } from 'react-router-dom';

import ListItem from './components/ListItem';
import Filter from './components/Filter';
import { SearchInput } from './components/SearchInput';

import getAddresses from '../../store/thunks/getAddresses';
import useSearchParamsState from '../../../../hooks/useSearchParamsState';

import './AddressList.scss';
import useParam from '../../../../hooks/useParam';
import useSetRefreshFn from '../../../../hooks/useSetRefreshFn';
import getAddressMeters from '../../store/thunks/getAddressMeters';

const AddressList = ({ height }) => {
  const dispatch = useDispatch();
  const { addresses, listLoading } =
    useSelector((store) => {
      return store.meterStore;
    }) || {};
  const activeMeterTypes = useParam('types', [], (arr) => arr?.map(Number));
  const activeTags = useParam('tags', [], (arr) => arr?.map(Number));

  const [search, setSearch] = useSearchParamsState('search', '');
  const [debouncedSearch, setDebouncedSearch] = useState(search);
  const [viewAddressesWithoutMeters, setViewAddressesWithoutMeters] =
    useState(false);
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearch(search);
    }, 300);
    return () => clearTimeout(timeoutId);
  }, [search]);

  useEffect(() => {
    if (debouncedSearch && !isNaN(Number(debouncedSearch))) {
      dispatch(
        getAddresses({
          types: activeMeterTypes,
          meterCode: debouncedSearch,
          allAddress: viewAddressesWithoutMeters,
          tags: activeTags,
        })
      );
    } else {
      dispatch(
        getAddresses({
          address: debouncedSearch || undefined,
          types: activeMeterTypes,
          allAddress: viewAddressesWithoutMeters,
          tags: activeTags,
        })
      );
    }
  }, [
    debouncedSearch,
    activeMeterTypes,
    viewAddressesWithoutMeters,
    activeTags,
  ]);

  const location = useLocation();
  const match = useRouteMatch('/Meters/address/:id');

  useSetRefreshFn(() => {
    if (debouncedSearch && !isNaN(Number(debouncedSearch))) {
      dispatch(
        getAddresses({
          types: activeMeterTypes,
          meterCode: debouncedSearch,
          allAddress: viewAddressesWithoutMeters,
          tags: activeTags,
        })
      );
    } else {
      dispatch(
        getAddresses({
          address: debouncedSearch || undefined,
          types: activeMeterTypes,
          allAddress: viewAddressesWithoutMeters,
          tags: activeTags,
        })
      );
    }

    if (match?.params?.id) {
      const houseId = match.params.id;
      const search = debouncedSearch.trim() || undefined;
      const meterCode = !isNaN(Number(search)) ? search : undefined;
      dispatch(
        getAddressMeters(houseId, activeMeterTypes, meterCode, activeTags)
      );
    }
  }, [
    debouncedSearch,
    activeMeterTypes,
    viewAddressesWithoutMeters,
    activeTags,
    match?.params?.id,
  ]);

  return (
    <div className="meters-addresses-list-container" style={{ height }}>
      <div>
        <SearchInput
          placeholder="Введите адрес или номер ОДПУ"
          className={'search-input'}
          size="default"
          value={search}
          onChange={(v) => setSearch(v.toLowerCase())}
        />
        <div
          onClick={() =>
            setViewAddressesWithoutMeters(!viewAddressesWithoutMeters)
          }
          style={{ cursor: 'pointer' }}
        >
          <Switch
            checked={viewAddressesWithoutMeters}
            style={{ marginRight: '10px' }}
          />
          <span>Показывать адреса без ОДПУ</span>
        </div>
        <Filter />
        {listLoading && (
          <Spin
            style={{ minHeight: 300 }}
            size="large"
            spinning={listLoading}
            tip="Загрузка..."
            delay={100}
          >
            <div></div>
          </Spin>
        )}
        {!listLoading && addresses && addresses.length > 0 && (
          <div className="meters-list">
            <AntdList
              itemLayout="vertical"
              dataSource={addresses}
              renderItem={(item) => (
                <Link
                  key={item.id}
                  to={{ ...location, pathname: `/Meters/address/${item.id}` }}
                  className="list-item-container"
                >
                  <ListItem item={item} />
                </Link>
              )}
            />
          </div>
        )}

        {!listLoading && addresses && addresses.length == 0 && (
          <Alert message="Адреса не найдены" type="info" showIcon />
        )}
      </div>
    </div>
  );
};
export default AddressList;
